export type LengthSource = 'apple' | 'tidal' | 'spotify';

const LENGTH_SOURCES: LengthSource[] = ['apple', 'tidal', 'spotify'];
const BIG_GAP_MS = 10_000;
const BIG_GAP_SHARE = 0.05;

function plural(count: number, word: string): string {
  return `${count} ${word}${count === 1 ? '' : 's'}`;
}

export function confidenceText(link: { cleanUses: number; wrongSongReports: number }): string {
  if (link.cleanUses === 0 && link.wrongSongReports === 0) return 'Not used yet';
  const reports = link.wrongSongReports === 0 ? 'no wrong-song reports' : plural(link.wrongSongReports, 'wrong-song report');
  return `Used ${plural(link.cleanUses, 'time')} · ${reports}`;
}

export function isBelowThreshold(link: { cleanUses: number }, threshold: number): boolean {
  return link.cleanUses < threshold;
}

export function lengthGapIsBig(aMs: number, bMs: number): boolean {
  const gap = Math.abs(aMs - bMs);
  return gap > BIG_GAP_MS && gap > BIG_GAP_SHARE * Math.max(aMs, bMs);
}

export function bigLengthGaps(lengths: Partial<Record<LengthSource, number>>): Array<[LengthSource, LengthSource]> {
  const gaps: Array<[LengthSource, LengthSource]> = [];
  for (let first = 0; first < LENGTH_SOURCES.length; first += 1) {
    for (let second = first + 1; second < LENGTH_SOURCES.length; second += 1) {
      const a = lengths[LENGTH_SOURCES[first]];
      const b = lengths[LENGTH_SOURCES[second]];
      if (a !== undefined && b !== undefined && lengthGapIsBig(a, b)) {
        gaps.push([LENGTH_SOURCES[first], LENGTH_SOURCES[second]]);
      }
    }
  }
  return gaps;
}

export function formatLengthMs(ms: number): string {
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
